import { apm } from "@elastic/apm-rum";
import { Close } from "@mui/icons-material";
import { Box, Fade, IconButton, Link, Modal } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import { ProviderType } from "shared/common/provider/pilegateprovider";
import { monitor } from "shared/common/services/apm-logging";
import { defaultStore } from "shared/common/stores/defaultStore";

interface FeedbackProps {
  showFeedback: boolean;
  handleClose: () => void;
  redirectToClassic: () => string;
}

export default function FeedbackForm({
  showFeedback,
  handleClose,
  redirectToClassic,
}: FeedbackProps) {
  const darkTheme = defaultStore((state) => state.darkTheme);

  const { t, i18n } = useTranslation();
  const link: string = redirectToClassic();
  const lang =
    i18n.language !== null
      ? i18n.language.includes("fr")
        ? "&lang=fr"
        : i18n.language.includes("de")
          ? "&lang=de"
          : "&lang=en"
      : "";

  return (
    <Modal
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        maxHeight: "100vh",
        padding: "30px",
      }}
      open={showFeedback}
      onClose={handleClose}
    >
      <Fade in={showFeedback}>
        <Box
          sx={{
            overflow: "auto",
            position: "relative",

            padding: {
              xs: "30px 20px 30px 20px",
              lg: "40px 160px 60px 160px",
            },

            backgroundColor: darkTheme ? "darkblue.main" : "white",
            borderRadius: "10px",
            height: "auto",
            maxHeight: "80%",
          }}
        >
          <IconButton
            onClick={() =>
              monitor(apm, "close-feedback-form | Settings", handleClose)
            }
            sx={{
              position: "absolute",
              top: { xs: "8px", lg: "24px" },
              right: { xs: "8px", lg: "24px" },
              color: darkTheme ? "white" : "darkblue.main",
              "@media (hover: hover)": {
                ":hover": { color: "secondary.main" },
              },
            }}
          >
            <Close />
          </IconButton>
          {/* <Typography
            variant="h3"
            component="h2"
            color={darkTheme ? "white" : "darkblue.main"}
            sx={{ width: "100%", textAlign: "center" }}
          >
            {t("feedback.title")}
          </Typography> */}
          <Box
            sx={{
              textAlign: "center",
              my: 2,
            }}
          >
            <iframe
              width="640px"
              height="480px"
              src={`https://forms.office.com/Pages/ResponsePage.aspx?id=vlQWN9AdoUKc_tNUdC0pe6eZOsRotwtNkGe1yVG4mRxUMVpWWVhVQUxFN0lPR1JKVkZMUE8zUVZMTC4u&embed=true%22${lang}`}
              style={{
                border: "none",
                maxWidth: "100%",
                maxHeight: "100vh",
              }}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Link
              href={link}
              sx={{
                padding: "8px 16px",
                borderRadius: "4px",
                textDecoration: "none",
                backgroundColor: darkTheme ? "white" : "darkblue.main",
                color: darkTheme ? "darkblue.main" : "white",
                "@media (hover: hover)": {
                  ":hover": {
                    backgroundColor: darkTheme ? "white" : "darkblue.main",
                    color: "secondary.main",
                  },
                },
              }}
            >
              {t("feedback.button_label")}
            </Link>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
}
